import React from 'react'
import { Card, Divider, Grid, Heading } from '@enterprise-ui/canvas-ui-react'
import { useNavigate } from 'react-router-dom'

export interface ReportSectionProps {
  title: string
  cards: ReportCardProps[]
}

export interface ReportCardProps {
  cardTitle: string
  url: string
  size?: number
}

export const ReportSection: React.FC<ReportSectionProps> = ({
  title,
  cards,
}) => {
  const navigate = useNavigate()
  return (
    <>
      <div className="hc-pa-normal">
        <Heading className="hc-mb-dense" size={5}>
          {title}
        </Heading>
        <Divider />
      </div>
      <Grid.Container justify="space-between">
        {cards.map((card) => (
          <Grid.Item xs={card.size ?? 4} key={card.cardTitle}>
            <Card>
              <div
                className="hc-pa-normal hc-ta-center"
                onClick={() => {
                  navigate(card.url)
                }}
              >
                {card.cardTitle}
              </div>
            </Card>
          </Grid.Item>
        ))}
      </Grid.Container>
    </>
  )
}
